import swaggerClient from "../remote-client";

export default class NotificationService {
  /**
   * Retrieve the number of the unread notifications
   */
  callGetNotificationsUnreadCount() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Notification.getNotificationsUnreadCount(
            {},
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          let numberOfUnreadNotifications = 0;
          if (result.body?.num) {
            numberOfUnreadNotifications = result.body.num;
          }
          resolve(numberOfUnreadNotifications);
        })
        .catch(error => reject(error));
    });
  }
  /**
   * Retrieve all the notifications for the given filters (paginated)
   * @param {*} payload
   */
  callGetNotifications(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Notification.getNotifications(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          let notifications = [];
          let numberOfNotifications = 0;
          if (result.body?.notifications) {
            notifications = result.body.notifications;
            numberOfNotifications = result.body.totalNumber;
          }
          resolve({
            notifications: notifications,
            numberOfNotifications: numberOfNotifications
          });
        })
        .catch(error => reject(error));
    });
  }
  /**
   * Mark as read the given notification
   * @param {*} notificationId
   */
  callMarkNotificationAsRead(notificationId) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Notification.postNotificationWithNotificationIdRead(
            { notificationId: notificationId },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(() => {
          resolve();
        })
        .catch(error => reject(error));
    });
  }
}
